import { Reducer } from 'redux';

import { IXMLState, XMLActionTypes } from './Types';

const initialState: IXMLState = {
    currentFile: '',
    files: new Map(),
    loadError: '',
};

const reducer: Reducer<IXMLState> = (state = initialState, action) => {
    switch (action.type) {
        case XMLActionTypes.ADD_FILE: {
            const files = state.files;

            files.set(action.payload[0], action.payload[1]);
            return {
                ...state,
                files,
            };
        }

        case XMLActionTypes.CLEAR_LIST: {
            const files = state.files;

            files.delete(action.payload);
            return {
                ...state,
                currentFile: '',
                files: new Map(),
            };
        }

        case XMLActionTypes.SET_CURRENT_FILE: {
            return {
                ...state,
                currentFile: action.payload,
            };
        }

        case XMLActionTypes.SET_ERROR: {
            return {
                ...state,
                loadError: action.payload,
            };
        }

        default: {
            return state;
        }
    }
};

export { reducer as XMLReducer };
